import { render, staticRenderFns } from "./base-layout-section.vue?vue&type=template&id=2564def4"
import script from "./base-layout-section.vue?vue&type=script&setup=true&lang=js"
export * from "./base-layout-section.vue?vue&type=script&setup=true&lang=js"
import style0 from "./base-layout-section.vue?vue&type=style&index=0&id=2564def4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports